import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {GlobalModule} from '@app/core/global.module';
import {InputSearchComponent} from './component/input-search.component';
import {ButtonModule} from '../button/modules/button.module';

@NgModule({
    declarations: [
        InputSearchComponent
    ],
    exports: [
        InputSearchComponent
    ],
    imports: [
        CommonModule,
        GlobalModule,
        ButtonModule,
    ]
})
export class InputSearchModule {
}
